import axios from '../utils/AxiosInstance'

export default {
  // namespaced: true,
  state: {
    profile: {},
    profileCounts: {}
  },
  mutations: {
    SET_PROFILE (store, val) {
      store.profile = val
    },
    SET_PROFILE_COUNTS (store, val) {
      store.profileCounts = val
    }
  },
  getters: {
    getProfile: (store) => {
      return store.profile
    },
    getPermissions: (store) => {
      return store.profile.permissions
    },
    getProfileCounts: (store) => {
      return store.profileCounts
    }
  },
  actions: {
    setProfile ({commit, dispatch, getters}) {
      return axios
      .get(`/accounts/${getters.getAccount._id}/profile`)
      .then((response) => {
        commit('SET_PROFILE', response.data)
        return response.data
      })
    },
    setProfileCounts ({commit, dispatch, getters, state}) {
      return axios
      .get(`/accounts/${getters.getAccount._id}/profile/counts`)
      .then((response) => {
        commit('SET_PROFILE_COUNTS', response.data)
        return response.data
      })
    },
    getNotificationSettings ({commit, dispatch, getters, state}) {
      return axios
      .get(`/accounts/${getters.getAccount._id}/profile/notification-settings`)
      .then((response) => {
        return response.data
      })
    },
    updateNotificationSettings ({commit, dispatch, getters, state}, data) {
      return axios
      .put(`/accounts/${getters.getAccount._id}/profile/notification-settings`, data)
      .then((response) => {
        dispatch('setWarn', { status: 'success' })
        return response.data
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/Profile.js